import { create } from "zustand/react";

export type UseInputStore = {
  inputMessage: Map<number, string>;
  file: Map<number, File>;
  AiLoading: Map<number, boolean>;

  SetInput(id: number, value: string | null): void;
  SetFile(id: number, value: File | null): void;
  SetAiLoading(id: number, value: boolean | null): void;
  RemoveSessionData(id: number): void;
};

export const useInputStore = create<UseInputStore>((set) => ({
  inputMessage: new Map<number, string>(),
  file: new Map<number, File>(),
  AiLoading: new Map<number, boolean>(),
  SetInput: (id, value) =>
    set((state) => {
      if (value === null) {
        const messages = new Map(state.inputMessage);
        messages.delete(id);

        return {
          inputMessage: messages,
        };
      }

      return {
        inputMessage: new Map(state.inputMessage).set(id, value),
      };
    }),
  SetFile: (id, value) =>
    set((state) => {
      if (value === null) {
        const files = new Map(state.file);
        files.delete(id);

        return {
          file: files,
        };
      }

      return {
        file: new Map(state.file).set(id, value),
      };
    }),
  SetAiLoading: (id, value) =>
    set((state) => {
      if (value === null) {
        const loadings = new Map(state.AiLoading);
        loadings.delete(id);

        return {
          AiLoading: loadings,
        };
      }

      return {
        AiLoading: new Map(state.AiLoading).set(id, value),
      };
    }),
  RemoveSessionData: (id) =>
    set((state) => {
      const loadings = new Map(state.AiLoading);
      const files = new Map(state.file);
      const messages = new Map(state.inputMessage);

      loadings.delete(id);
      files.delete(id);
      messages.delete(id);

      return {
        AiLoading: loadings,
        file: files,
        inputMessage: messages,
      };
    }),
}));
